/** Prefetch lazy route chunks on sidebar hover to cut navigation paint time. */

const prefetchedRoutes = new Set<string>();

const ROUTE_IMPORTS: Record<string, () => Promise<unknown>> = {
  "/dashboard": () => import("@/pages/Dashboard"),
  "/assets": () => import("@/pages/Assets"),
  "/transactions": () => import("@/pages/Transactions"),
  "/goals": () => import("@/pages/Goals"),
  "/reports": () => import("@/pages/Reports"),
  "/expenses": () => import("@/pages/Expenses"),
  "/investments": () => import("@/pages/Investments"),
  "/calculators": () => import("@/pages/Calculators"),
  "/family": () => import("@/pages/Family"),
  "/subscription": () => import("@/pages/Subscription"),
  "/splitmage": () => import("@/pages/SplitMage"),
  "/reports/analysis": () => import("@/pages/PortfolioAnalysis"),
  "/settings": () => import("@/pages/Settings"),
  "/profile": () => import("@/pages/Profile"),
  "/account": () => import("@/pages/AccountLegacyRedirect"),
  "/blog": () => import("@/pages/blog/BlogList"),
  "/admin": () => import("@/pages/Admin"),
  "/preference": () => import("@/pages/PreferenceLegacyRedirect"),
};

export function normalizeRoutePath(path: string): string {
  const [withoutQuery] = path.split("?")[0].split("#");
  if (withoutQuery.length > 1 && withoutQuery.endsWith("/")) {
    return withoutQuery.slice(0, -1);
  }
  return withoutQuery;
}

export function prefetchRoute(path: string): void {
  const normalized = normalizeRoutePath(path);
  const loader = ROUTE_IMPORTS[normalized];
  if (!loader || prefetchedRoutes.has(normalized)) {
    return;
  }
  prefetchedRoutes.add(normalized);
  loader().catch(() => {
    prefetchedRoutes.delete(normalized);
  });
}

/** @internal test helper */
export function resetRoutePrefetchCacheForTests(): void {
  prefetchedRoutes.clear();
}
